import React,{Component} from 'react';
import './ConsortiumPage.css';

import { consortiumBanner, logo } from '../../_utils/images';
import Page from '@acri-tools/react-tools/components/Page/Page';
import routes from '../../_utils/routes';
import Footer from '../../components/Footer/Footer';
import Partners from '@acri-tools/react-tools/components/Partners/Partners';
import { consortium } from './consortium';

interface Props{
}
interface State{
}

export default class ConsortiumPage extends Component<Props, State> {

    render(){
        return (
        <Page 
            id="partners"
            title="Partners"
            footer={<Footer/>}
            banner={{
                bannerImage: consortiumBanner,
                topBar:{
                    routes: routes,
                    logo: logo,
                }
            }}
        >
            <div className="page-content">
                <div className="centered-content padding">
                    {/* <div className="title-1">Partners</div> */}
                    {/* <div className="subtitle"></div> */}
                    <Partners partners={consortium}/>
                </div>
            </div>
        </Page>
        );
    }


};